import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { StepperEnum } from 'src/app/entities/stepperEnum';
import { ProcessService } from 'src/app/services/process.service';
import { SharedService } from '../../../services/sharedService';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { merge, Subject, Subscription } from 'rxjs';
import { debounce, debounceTime, share, startWith, switchMap } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { NgSelectComponent } from '@ng-select/ng-select';
import { RiskService } from 'src/app/services/riskService';
import { yearList } from 'src/app/util/yearPicker';
import { UserService } from 'src/app/services/user.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastService } from 'src/app/services/toast-service';
import { TranslateService } from '@ngx-translate/core';
import { IfuService } from 'src/app/services/ifuService';
import { SourceService } from 'src/app/services/sourceService';
import { displayOrDash } from 'src/app/utils/display';

@Component({
  selector: 'app-step-tabber',
  templateUrl: './step-tabber.component.html',
  styleUrls: ['./step-tabber.component.css']
})
export class StepTabberComponent implements OnInit {
  paramQuery: string;
  filterForm: UntypedFormGroup;
  modalRef?: BsModalRef;
  obs: Subscription;
  executionTasks = []
  displayOrDash = displayOrDash;
  constructor(private processService: ProcessService, private sharedService: SharedService, private riskService: RiskService,
    private ifuService: IfuService,
    private modalService: BsModalService,
    public toastService: ToastService,
    private translateService: TranslateService,
    private sourceService: SourceService,
    private userService: UserService) {

    this.filterForm = new UntypedFormGroup({
      search: new UntypedFormControl(),
      year: new UntypedFormControl(),
      verifyPeriod: new UntypedFormControl(),
      submitPeriod: new UntypedFormControl(),
      semester: new UntypedFormControl(),
      executionTask: new UntypedFormControl(),
    });
    // /this.filterForm.get('semester').setValue(this.getSemester());
  }
  risks$: any[] = [];
  risksLoading = false;
  risksInput$ = new Subject<string>();
  ifus$: any[] = [];
  sources$: any[] = [];
  performers$: any[] = [];
  ifusLoading = false;
  ifusInput$ = new Subject<string>();
  years = []

  @ViewChild('riskMulti', { static: false }) public riskMulti: NgSelectComponent;
  @Input() steps: any[];
  @Input() type: any;
  @Input() processes: any;
  numPages = 0;
  maxSize = 10;
  bigTotalItems = 0;
  bigCurrentPage = 1;
  from = 0;
  to = 0;
  currentPage = 1;
  totalCount = 0;
  respProcesses: any;
  tab: any;
  // Evaluation tab: filter block is collapsible (ngbCollapse) and starts collapsed
  filtersCollapsed = true;
  searchText: any;
  editor = false;
  risks = []
  ifus = []
  sources = []
  performers = []
  activeId: any = 0;
  // Number of active filters; shown as a badge on the Evaluation filter toggle
  // so a collapsed panel can't silently hide an applied filter.
  activeFilterCount() {
    const unset = v => v === null || v === undefined || v === '' || v === '-';
    const form = this.filterForm ? this.filterForm.value : {};
    let count = ['search', 'year', 'verifyPeriod', 'submitPeriod', 'semester', 'executionTask']
      .filter(k => !unset(form[k])).length;
    [this.risks, this.ifus, this.sources, this.performers].forEach(arr => {
      if (arr && arr.length) count++;
    });
    return count;
  }
  printValue(event, valType) {
    if (valType === 'risk')
      this.risks = event.map(function (item) {
        return item['key'];
      })
    if (valType === 'ifu')
      this.ifus = event.map(function (item) {
        return item['key'];
      })
    if (valType === 'source') {
      this.sources = event.map(function (item) {
        return item;
      })
    }
    if (valType === 'performer') {
      this.performers = event.map(function (item) {
        return item;
      })
    }
    this.processService.getProcesses(this.getStepParam(this.tab), null,
      localStorage.getItem('currentControlType'), this.from, this.maxSize,
      this.tab === 'DONE' ? 'COMPLETED' : null, this.filterForm.value.search, this.risks,
      this.filterForm.value.verifyPeriod, this.filterForm.value.submitPeriod,
      this.filterForm.value.semester, this.filterForm.value.year, this.editor, this.ifus, this.filterForm.value.executionTask,
      this.sources,
      this.performers
    ).subscribe(processes => {
      this.paramQuery = processes.query;
      this.to = processes.records.length;
      this.respProcesses = processes;
      this.setRecordsAndFilters(processes, false)
      this.setupPaginator();
    }
    );
  }
  ngOnInit() {
    this.years = yearList()
    this.riskService.getTotalRiskList().subscribe(risks => {
      this.risks$ = risks;
    })
    this.ifuService.getTotalIfuList().subscribe(ifus => {
      this.ifus$ = ifus;
    })
    this.sourceService.getTotalSourceList().subscribe(sources => {
      this.sources$ = sources;
      this.sources$.unshift('N/A')
    })
    this.sourceService.getTotalExecutiveList().subscribe(performers =>{
      this.performers$ = performers;
      this.performers$.unshift('N/A')
    })
    this.userService.getCurrentUser().subscribe(user => {

      const roles = ['CONTROLLER', 'DIRECTOR_APPROVER', 'DIRECTOR_GENERAL', 'COORDINATOR', 'INSPECTOR', 'CHEF'];
      if (!roles.some(item => user.roles.includes(item))) {
        this.editor = true
      }
      if (this.type === StepperEnum.List) {
        this.obs = this.filterForm.valueChanges
          .pipe(
            debounceTime(500),
            switchMap(id => {
              return this.processService.getProcesses(this.getStepParam(this.tab), null,
                localStorage.getItem('currentControlType'), this.from, this.maxSize,
                this.tab === 'DONE' ? 'COMPLETED' : null, this.filterForm.value.search, this.risks,
                this.filterForm.value.verifyPeriod, this.filterForm.value.submitPeriod, this.filterForm.value.semester, this.filterForm.value.year, this.editor, this.ifus, this.filterForm.value.executionTask, this.sources);
            })
          )
          .subscribe(processes => {
            this.paramQuery = processes.query;
            this.to = processes.records.length;
            this.respProcesses = processes;
            this.setRecordsAndFilters(processes, false)
            this.setupPaginator();
          }
          );
        this.processService.getProcesses(this.getStepParam(this.tab), null,
          localStorage.getItem('currentControlType'), this.from, this.maxSize, null, this.filterForm.value.search, this.risks, this.filterForm.value.verifyPeriod, this.filterForm.value.submitPeriod,
          this.filterForm.value.semester, this.filterForm.value.year, this.editor, this.ifus, this.filterForm.value.executionTask, this.sources).subscribe(processes => {
            this.paramQuery = processes.query;
            this.to = processes.records.length;

            this.respProcesses = processes
            this.setRecordsAndFilters(processes, false)
            this.setupPaginator();
          });
      }
      this.sharedService.teamChangedEventEmitter.subscribe(teamId => {
        this.processService.getProcesses(this.getStepParam(this.tab), teamId, localStorage.getItem('currentControlType'), this.from, this.maxSize, this.tab === 'DONE' ? 'COMPLETED' : null, this.filterForm.value.search, this.risks, this.filterForm.value.verifyPeriod, this.filterForm.value.submitPeriod, this.filterForm.value.semester,
          this.filterForm.value.year, this.editor, this.ifus, this.filterForm.value.executionTask, this.sources).subscribe(processes => {
            this.paramQuery = processes.query;
            this.setRecordsAndFilters(processes, false)
          });
      });
      this.sharedService.controlTypeChangedEventEmitter.subscribe(controlType => {

        this.processService.getProcesses(this.getStepParam(this.tab), null, controlType, this.from, this.maxSize, this.tab === 'DONE' ? 'COMPLETED' : null, this.filterForm.value.search,
          this.risks, this.filterForm.value.verifyPeriod, this.filterForm.value.submitPeriod,
          this.filterForm.value.semester, this.filterForm.value.year, this.editor, this.ifus, this.filterForm.value.executionTask, this.sources).subscribe(processes => {
            this.paramQuery = processes.query;
            this.setRecordsAndFilters(processes, true)
          });
      });
      this.sharedService.addProcessEventEmitter.subscribe(teamId => {
        this.processService.getProcesses(this.getStepParam(this.tab), null,
          localStorage.getItem('currentControlType'), this.from, this.maxSize, this.tab === 'DONE' ? 'COMPLETED' : null, this.filterForm.value.search,
          this.risks, this.filterForm.value.verifyPeriod, this.filterForm.value.submitPeriod, this.filterForm.value.semester,
          this.filterForm.value.year, this.editor, this.ifus, this.filterForm.value.executionTask, this.sources).subscribe(processes => {
            this.paramQuery = processes.query;
            this.respProcesses = processes;
            this.setRecordsAndFilters(processes, false)
            this.setupPaginator();
          });
      });
    });
  }

  downloadList(apiUrl) {
    this.processService.getProcessesFile(apiUrl, this.getStepParam(this.tab), null,
      localStorage.getItem('currentControlType'), this.from, this.maxSize, this.tab === 'DONE' ? 'COMPLETED' : null,
      this.filterForm.value.search, this.risks, this.filterForm.value.verifyPeriod,
      this.filterForm.value.submitPeriod, this.filterForm.value.semester, this.filterForm.value.year, this.editor, this.ifus, this.filterForm.value.executionTask, this.sources, this.performers).subscribe(processes => {
        const blob = processes;
        const file = new Blob([blob], {});
        saveAs(file, localStorage.getItem('currentControlTypeName') + '.xlsx');
      });
  }
  changePage(event) {
    this.from = (event - 1) * this.maxSize;
    this.to = this.maxSize
    this.setPage(event);
  }

  setPage(pageNo: number): void {

    this.currentPage = pageNo;
    this.fireQueryEvent();
  }

  fireQueryEvent() {
    if (this.tab || this.currentPage > 1) {
      this.processService.getProcesses(this.getStepParam(this.tab), null,
        localStorage.getItem('currentControlType'), this.from, this.maxSize, this.tab === 'DONE' ? 'COMPLETED' : null,
        this.filterForm.value.search, this.risks, this.filterForm.value.verifyPeriod,
        this.filterForm.value.submitPeriod, this.filterForm.value.semester, this.filterForm.value.year, this.editor, this.ifus, this.filterForm.value.executionTask, this.sources).subscribe(processes => {
          this.paramQuery = processes.query;
          this.to = processes.records.length;
          this.respProcesses = processes;
          this.setRecordsAndFilters(processes, false)
          this.setupPaginator();
        });
    }
    if (this.currentPage > 1 && !this.tab) {
      this.tab = 'ALL'
    }

  }

  isSingle() {
    return this.type === StepperEnum.Single;
  }

  getProcessesByStep(step) {
    return this.processes.filter(elem => elem.step === step);
  }

  // Maps a tab key to the backend `step` param. 'ALL' clears the filter;
  // the synthetic 'DONE' tab reuses the EVALUATION step (combined with
  // status=COMPLETED below) so Done shows completed evaluations.
  getStepParam(tab: any) {
    if (tab === 'ALL') return null;
    if (tab === 'DONE') return 'EVALUATION';
    return tab;
  }

  getTab(tab) {
    this.tab = tab;
    // Start collapsed on Evaluation, but never hide active filters behind a
    // closed panel — auto-expand when any filter is applied.
    this.filtersCollapsed = this.activeFilterCount() === 0;
    // Clear current rows/count immediately so the previous tab's data isn't
    // shown under the new tab's layout while its request is in flight.
    this.processes = null;
    this.respProcesses = null;
    this.totalCount = 0;
    this.processService.getProcesses(this.getStepParam(tab), null,
      localStorage.getItem('currentControlType'), this.from, this.maxSize, tab === 'DONE' ? 'COMPLETED' : null,
      this.filterForm.value.search, this.risks, this.filterForm.value.verifyPeriod,
      this.filterForm.value.submitPeriod,
      this.filterForm.value.semester, this.filterForm.value.year, this.editor, this.ifus, this.filterForm.value.executionTask, this.sources)
      .subscribe(processes => {
        this.paramQuery = processes.query;
        this.respProcesses = processes;
        this.setRecordsAndFilters(processes, false)
        this.setupPaginator();
      });
  }

  setupPaginator(): void {
    this.bigTotalItems = this.totalCount = this.respProcesses.total;
    if (this.currentPage === 1) {
      if (this.respProcesses.total > 0) {

      }
      this.to = this.respProcesses.total < 11 ? this.respProcesses.total : 10;
    }
  }

  getSemester() {
    const d = new Date();
    let month = d.getMonth();
    if (month < 6)
      return 2;
    return 1;
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }
  confirmApproveAll() {
    this.processService.approveAll(this.paramQuery).subscribe(res => {
      this.currentPage = 1;
      this.showSuccess('CONTROL-MODULE.APPROVED_ALL');
      this.fireQueryEvent()
      this.modalRef.hide()
    })
  }

  showSuccess(text) {
    this.toastService.show(this.translateService.instant(text), { classname: 'bg-success text-light', delay: 2000 });
  }

  setRecordsAndFilters(resp, reloadExecTasks) {
    this.processes = resp.records;
    this.totalCount = resp.total;
    if ((reloadExecTasks || this.executionTasks.length === 0) && resp.total && resp.total > 0 && localStorage.getItem('currentControlType') !== null && localStorage.getItem('currentControlType') !== 'null') {
      this.executionTasks = []
      let containsExec = false;
      let ind = 0
      while (!containsExec) {
        var st = this.processes[ind].tasks.filter(tt => tt.step === 'EXECUTION')
        if (st.length > 0) {
          containsExec = true
          this.executionTasks = st.map(elem => {
            const s = {}
            s['name'] = elem.name
            s['key'] = elem.key
            return s
          })
        }
        ind++;
      }
    }
  }
}


